import React, { useContext } from "react";

import Container from "../../components/container";
import StudyCard from "../../components/StudyCard";
import libraryImg from "../../assets/newImages/library-img.svg";
import BooksImage from "../../assets/images/books-image.webp";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  catalogueData,
  catalogueError,
  catalogueLoading,
} from "../../redux/selectors";
import Button from "../../components/EmptyButton";
import { getCatalogue } from "../../redux/actions";
import Context from "../../services/Context";
import { getUser } from "../../helpers";

const YourLibraryPage = (props) => {
  const history = useHistory();

  const { data, loading, getCatalogue } = props;
  const [user, setUser] = useState(JSON.parse(getUser()));

  const { value, updateValue } = useContext(Context);
  const userCurrency = value?.userCurrency || user?.user_currency;
  const userIsLaw = value?.is_law || user?.is_law;

  const [showCatalogue, setCatalogue] = useState([]);

  useEffect(() => {
    getCatalogue(null);
  }, []);
  useEffect(() => {
    if (data?.data?.length) {
      setCatalogue(data?.data);
    }
  }, [data]);

  return (
    <div className="bg-white bg-subscription-bottom bg-no-repeat bg-contain bg-bottom pt-10 xl:pt-20">
      <Container>
        <div className="flex flex-col-reverse lg:grid lg:grid-cols-12 lg:gap-8 xl:gap-14">
          <div className="lg:col-span-8">
            <h2 className="font-bold text-h5 md:text-h4 custom:mt-14 custom:text-36 leading-5 md:leading-6 xl:leading-12 md:mb-7 lg:mb-10 xl:mb-12">
              My library
            </h2>
            {userCurrency === "UK" && userIsLaw === true ? (
              <>
                <p className="text-black text-16 font-500 leading-8 xl:leading-10 xl:text-18">
                  On your library page, you'll discover all the study modules
                  you enrolled in. The distinction between getting a
                  subscription or a study module individually:
                </p>
                <ul className="mt-5 xl:mt-30" style={{ listStyle: "none" }}>
                  <li className="flex gap-3" style={{ marginBottom: "20px" }}>
                    <span className="flex-shrink-0 custom-bullet"></span>
                    <span className="text-black text-16 font-500 leading-5 xl:leading-6 xl:text-18">
                      Enrolling in study modules requires a one-time payment for
                      each module. Afterward, the modules you get are added to
                      your library permanently, with no recurring payments.
                    </span>
                  </li>
                  <li className="flex gap-3" style={{ marginBottom: "20px" }}>
                    <span className="flex-shrink-0 custom-bullet"></span>
                    <span className="text-black text-16 font-500 leading-5 xl:leading-6 xl:text-18">
                      Opting for a subscription grants access to all our study
                      materials for English law degree, but only for a limited
                      time. Subscription renews automatically through recurring
                      payments until cancellation.
                    </span>
                  </li>
                </ul>
              </>
            ) : (
              <>
                <p className="text-black text-16 font-500 leading-8 xl:leading-10 xl:text-18">
                  On your library page, you'll find all the study modules you’ve
                  enrolled in. Enrolling in study modules requires a one-time
                  payment for each module. Afterward, the modules you get are
                  added to your library permanently, with no recurring payments.
                </p>
              </>
            )}
          </div>
          <div className="lg:col-span-4 flex items-end justify-center">
            <img src={libraryImg} alt="library-img" />
          </div>
        </div>
        <div className="flex flex-col">
          <h3 className="font-bold text-h5 md:text-h4 custom:mt-14 custom:text-36 leading-5 md:leading-6 xl:leading-12 mt-4">
            Study Materials
          </h3>

          <div className="md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 md:gap-6 xl:gap-8 custom:grid custom:grid-cols-3 w-full mt-10">
            {
              showCatalogue.length > 0 ? (
                showCatalogue.map(
                  (item, index) =>
                    item.is_paid && (
                      <StudyCard
                        key={index} // Add key prop
                        image={item.study_module.image_url}
                        alt="Statue"
                        item={item}
                        cardTitle={item?.study_module.title}
                        cardDescription={item?.study_module.university}
                      />
                    )
                )
              ) : (
                <p className="col-span-full text-center">No Item in Library</p>
              ) // Centered message
            }
          </div>
        </div>
        <div className="pt-20 xl:pt-28 flex flex-col items-center gap-5 md:gap-10 md:flex-row custom:justify-center max-w-1160 mx-auto">
          {/* <Button filled onClick={() => history.push("/subscription")}>
              <p className="text-center text-14 xl:text-body-large">
                Get All Contract Law <br /> Materials FOR ONLY £20
              </p>
            </Button>
          </div>
          <div>
            <p className="my-8 font-bold text-17 md:mx-5 xl:mx-7">OR</p>
          </div>
          <div className="w-11/12 custom:w-1/3 xl:w-80">
            <Button filled onClick={() => history.push("/subscription")}>
              <p className="text-center text-14 xl:text-body-large">
                Get all the Study Modules <br />
                for £7.5/month
              </p>
            </Button> */}
          <Button onClick={() => history.push("/subscription")}>
            <p className="text-center text-14 xl:text-body-large">
              Unlock access to all study materials with a subscription
            </p>
          </Button>
          <Button onClick={() => history.push("/")}>
            <p className="text-center text-14 xl:text-body-large">
              Buy study modules individually to access them forever
            </p>
          </Button>
        </div>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: catalogueLoading(state),
  error: catalogueError(state),
  data: catalogueData(state),
});

const mapDispatchToProps = (dispatch) => ({
  getCatalogue: (id) => dispatch(getCatalogue(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(YourLibraryPage);
